export default "__VITE_ASSET__D7fAwyPd__"